const navbar = {
  packages: "Paquetes", // translated
  experiences: "Experiencias", // translated
  close: "Cerrar", // translated
  hotelPackages: "Paquetes de hotel", // translated
  hotDeals: "Las mejores ofertas", // translated
  dashboard: "Panel", // translated
  pricing: "Precios", // translated
};

export default navbar;
